import * as React from 'react';

import NutshellLogo from 'shells/logos/nutshell-logo.svg';

import type {Import2StatusFragment_crmOption as CrmOption} from 'nutshell-graphql-types';

import {Body} from '../typography/body';

import {getCrmLogoFromType} from './helpers';

import styles from './logos.module.css';

type Props = {
    crmOption: CrmOption;
};

export function Logos(props: Props) {
    return (
        <div className={styles.container}>
            <img
                src={getCrmLogoFromType(props.crmOption.type)}
                alt={props.crmOption.label}
                className={styles.image}
            />
            <Body size='large' isBold={true}>
                +
            </Body>
            <NutshellLogo width={159} height={63} />
        </div>
    );
}
